function openDetailsFromHash() {
  // Get the current hash
  const hash = window.location.hash.substring(1); // Remove the # character

  if (hash) {
    // Find the element with the matching id
    const element = document.getElementById(hash);
    // Check if the element is a details element
    if (element && element.tagName.toLowerCase() === 'details') {
      // Open the details element
      element.open = true;
    }
  }
}

// Call the function on page load
openDetailsFromHash();

// Call the function on hash change
window.addEventListener('hashchange', openDetailsFromHash);
